export default __webpack_public_path__ + "static/media/project9.b437bcd5.JPG";